<template>
  <div id="row-style" class="container-fluid col-12 pb-4">
    <div class="row justify-content-center">
      <div class="col-11 col-lg-10 col-xl-9">
        <div class="row justify-content-center">
          <div class="text-left col-12 align-self-center mt-4">
            <h1>{{ $t('understand-title') }}</h1>
            {{ $t('understand-content-1') }}
          </div>
          <div class="col-12 align-self-center mt-4">
            <img src="../assets/Understand_preprocessing.png" class="img-fluid" alt="preprocessing">
          </div>
          <div class="col-12 align-self-center mt-4">
            <img src="../assets/Understand_annotation.png" class="img-fluid" alt="annotation">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UnderstandContent',
  props: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#row-style {
  background-color: #cbcbcb;
}
</style>
